import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { IColumnDefinition } from '@common/models/column-definition';
import { IResizedColumn } from '@common/models/table';

@Injectable({
  providedIn: 'root'
})
export class WidgetColumnsHttpService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlProvider: UrlBuilderService) { }

  getAllColumns(widgetConfigId: number) {
    const url = this.urlProvider.getUrl(`widget/${widgetConfigId}/columns/all`);
    return this.http.get<IColumnDefinition[]>(url);
  }

  getAvailableColumns(widgetInstanceId: number) {
    const url = this.urlProvider.getUrl(`widget/${widgetInstanceId}/columns/available`);
    return this.http.get<IColumnDefinition[]>(url);
  }

  resetColumns(widgetInstanceId: number) {
    const url = this.urlProvider.getUrl(`widget/${widgetInstanceId}/columns/reset`);
    return this.http.put<IColumnDefinition[]>(url, []);
  }

  resizeColumn(widgetInstanceId: number, column: IResizedColumn) {
    const url = this.urlProvider.getUrl(`widget/${widgetInstanceId}/columns/resize`);
    return this.http.put(url, column);
  }

  reorderColumns(widgetInstanceId: number, selectedFieldNames: string[]) {
    const url = this.urlProvider.getUrl(`widget/${widgetInstanceId}/columns/reorder`);
    return this.http.put(url, selectedFieldNames);
  }

  changeSelectedColumns(widgetInstanceId: number, selectedColumns: IColumnDefinition[]) {
    const url = this.urlProvider.getUrl(`widget/${widgetInstanceId}/columns/selected`);
    return this.http.put<IColumnDefinition[]>(url, selectedColumns);
  }

  deleteUserSpecifiedWidgetColumns(widgetConfigurationId: number) {
    const url = this.urlProvider.getUrl(`widget/${widgetConfigurationId}/columns/deletecolumnsforwidgetconfigurationId`);
    return this.http.put<IColumnDefinition[]>(url, []);
  }
}
